import { useState } from 'react';
import MaterielDrawerAssignTab from './MaterielDrawerAssignTab';
import MaterielDrawerCapabilitiesTab from './MaterielDrawerCapabilitiesTab';
import MaterielDrawerFooter from './MaterielDrawerFooter';
import MaterielDrawerHeader from './MaterielDrawerHeader';
import MaterielDrawerHistoryTab from './MaterielDrawerHistoryTab';
import MaterielDrawerInfoTab from './MaterielDrawerInfoTab';
import MaterielDrawerJournalTab from './MaterielDrawerJournalTab';
import MaterielDrawerTabs from './MaterielDrawerTabs';

/**
 * Drawer fiche matériel U3 — lecture seule.
 * @param {{
 *   listItem?: object|null,
 *   detail?: object|null,
 *   detailLoading?: boolean,
 *   detailError?: string|null,
 *   journal?: object[],
 *   journalLoading?: boolean,
 *   journalError?: string|null,
 *   onClose?: () => void,
 *   onRetryDetail?: () => void,
 *   onRetryJournal?: () => void,
 * }} props
 */
export default function MaterielDrawer({
  listItem = null,
  detail = null,
  detailLoading = false,
  detailError = null,
  journal = [],
  journalLoading = false,
  journalError = null,
  onClose,
  onRetryDetail,
  onRetryJournal,
  onAssign,
  onStock,
  actionBusy = false,
}) {
  const [tab, setTab] = useState('info');
  const headerItem = detail || listItem;

  if (!listItem && !detail) {
    return (
      <aside className="bg-white border border-gray-200 rounded-lg p-4 min-h-[16rem] flex items-center justify-center lg:sticky lg:top-4 lg:self-start">
        <p className="text-sm text-gray-500 text-center px-4">
          Sélectionnez un matériel dans la liste pour ouvrir la fiche.
        </p>
      </aside>
    );
  }

  const bodyItem = detail || listItem;

  return (
    <aside className="bg-white border border-gray-200 rounded-lg flex flex-col min-h-[22rem] max-h-[85vh] lg:sticky lg:top-4 lg:self-start overflow-hidden">
      <MaterielDrawerHeader item={headerItem} onClose={onClose} />

      {detailError ? (
        <div className="mx-4 mt-3 rounded-md border border-red-200 bg-red-50 px-3 py-2 space-y-1">
          <p className="text-xs text-red-800">
            Impossible de charger le détail complet de la fiche.
          </p>
          {typeof onRetryDetail === 'function' ? (
            <button
              type="button"
              onClick={onRetryDetail}
              className="text-xs font-medium text-red-900 underline"
            >
              Réessayer
            </button>
          ) : null}
        </div>
      ) : null}

      <MaterielDrawerTabs active={tab} onChange={setTab} />

      <div className="flex-1 overflow-y-auto px-4 py-4">
        {tab === 'info' ? (
          <MaterielDrawerInfoTab item={bodyItem} loading={detailLoading && !detail} />
        ) : null}
        {tab === 'assign' ? (
          <MaterielDrawerAssignTab item={bodyItem} loading={detailLoading && !detail} />
        ) : null}
        {tab === 'caps' ? (
          <MaterielDrawerCapabilitiesTab
            item={bodyItem}
            loading={detailLoading && !detail}
          />
        ) : null}
        {tab === 'journal' ? (
          <MaterielDrawerJournalTab
            items={journal}
            loading={journalLoading}
            error={journalError}
            onRetry={onRetryJournal}
          />
        ) : null}
        {tab === 'history' ? <MaterielDrawerHistoryTab /> : null}
      </div>

      <MaterielDrawerFooter
        item={bodyItem}
        onAssign={onAssign}
        onStock={onStock}
        actionBusy={actionBusy}
      />
    </aside>
  );
}
